import React from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import './style.scss';
import { identity } from "../../../../../utils/getIdentity";

const MultisendSummary = ({ currency, multisendEstimate, wallet, isMainCurrency }) => {
  const { t } = useTranslation();

  const getTokenBalance = () => {
    if (wallet?.tokens?.[0]?.balance?.value) return wallet.tokens[0].balance.value;
    const v2Asset = wallet?.balances?.find(b => b?.currency?.id === currency?._id);
    return v2Asset?.balance?.value;
  };

  const getNativeBalance = () => {
    if (wallet?.balance?.value) return wallet.balance.value;
    const v2Native = wallet?.balances?.find(b => b?.currency?.currencyType === 'currency');
    return v2Native?.balance?.value;
  };

  return (
    <div className="multisend-summary">
      <div className={`multisend-summary__title multisend-summary__title-${identity}`}>{t('multisendWithdraw.summary')}</div>
      <div className="multisend-summary__table">
        <Row gutter={[2, 2]}>
          <Col span={24} md={12}>
            <div className={`multisend-summary__cell multisend-summary__cell-${identity}`}>
              <span className={`multisend-summary__value multisend-summary__value-${identity}`}>{multisendEstimate.multisendWallets.length}</span>
              <span className={`multisend-summary__name multisend-summary__name-${identity}`}>{t('multisendWithdraw.totalNumberOfAddresess')}</span>
            </div>
          </Col>
          {!isMainCurrency.length ? (
            <Col span={24} md={12}>
              <div className={`multisend-summary__cell multisend-summary__cell-${identity}`}>
                <span className={`multisend-summary__value multisend-summary__value-${identity}`}>
                  {multisendEstimate.allowance} {currency.title}
                </span>
                <span className={`multisend-summary__name multisend-summary__name-${identity}`}>{t('multisendWithdraw.totalNumberOfTokensToBeSent')}</span>
              </div>
            </Col>
          ) : null}
          <Col span={24} md={12}>
            <div className={`multisend-summary__cell multisend-summary__cell-${identity}`}>
              <span className={`multisend-summary__value multisend-summary__value-${identity}`}>{multisendEstimate.countTxs}</span>
              <span className={`multisend-summary__name multisend-summary__name-${identity}`}>{t('multisendWithdraw.totalNumberOfTransactionsNeed')}</span>
            </div>
          </Col>
          {!isMainCurrency.length ? (
            <Col span={24} md={12}>
              <div className={`multisend-summary__cell multisend-summary__cell-${identity}`}>
                <span className={`multisend-summary__value multisend-summary__value-${identity}`}>
                  {getTokenBalance()} {currency?.title}
                </span>
                <span className={`multisend-summary__name multisend-summary__name-${identity}`}>{t('multisendWithdraw.yourTokenBalance')}</span>
              </div>
            </Col>
          ) : null}

          <Col span={24} md={24}>
            <Row gutter={[2, 0]}>
              <Col span={24} md={12}>
                <Row gutter={[0, 2]}>
                  <Col span={24} md={24}>
                    <div className={`multisend-summary__cell multisend-summary__cell-${identity}`}>
                      <span className={`multisend-summary__value multisend-summary__value-${identity}`}>
                        {multisendEstimate.minerFee} {multisendEstimate.currencyFee}
                      </span>
                      <span className={`multisend-summary__name multisend-summary__name-${identity}`}>
                        {t('multisendWithdraw.aproximateCostsOfMinerFee')}
                      </span>
                    </div>
                  </Col>
                  <Col span={24} md={24}>
                    <div className={`multisend-summary__cell multisend-summary__cell-${identity}`}>
                      <span className={`multisend-summary__value multisend-summary__value-${identity}`}>
                        {multisendEstimate.systemFee} {multisendEstimate.currencyFee}
                      </span>
                      <span className={`multisend-summary__name multisend-summary__name-${identity}`}>
                        {t('multisendWithdraw.aproximateCostsOfSystemFee')}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={24} md={12}>
                <Row gutter={[0, 2]} className="multisend-summary__cell-united">
                  <Col span={24} md={24}>
                    <div className={`multisend-summary__cell multisend-summary__cell-${identity}`}>
                      <span className={`multisend-summary__value multisend-summary__value-${identity}`}>
                        {getNativeBalance()} {multisendEstimate.currencyFee}
                      </span>
                      <span className={`multisend-summary__name multisend-summary__name-${identity}`}>
                        {t('multisendWithdraw.yourCurrencyBalance', { currency: multisendEstimate.currencyFee })}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default MultisendSummary;
